import { AxiosRequestConfig } from 'axios'

const getModelById = (id: string): AxiosRequestConfig => ({
  url: `/models/${id}`,
  method: 'GET',
})

export { getModelById }
